import React from "react";
import icon4 from "../img/svg/asset-11.svg";

const TeamCard = ({ teamData }) => {
  //   console.log(teamData);
  return (
    <>
      <section className="main-container">
          <p className="main-p1">What we do</p>
          <h2 className="main-h1">Services for you</h2>
        <div className="sub-container">
          {teamData.map((curElem) => {
            return (
              <>
                <div className="card">
                  <img src={icon4} alt="" className="card-img" />
                  <span>
                    <h4 className="card-h4">{curElem.name}</h4>
                    <p className="card-p1">{curElem.description}</p>
                  </span>
                </div>
              </>
            );
          })}
        </div>
      </section>
    </>
  );
};

export default TeamCard;
